module.exports = __webpack_public_path__ + "img/icon-03.bdc833a0.png";